<template>
    <div class="container">
        <router-view></router-view>
    </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'LayoutExternoBackground',
    setup() {

    },
});
</script>

<style lang="scss" scoped>

.container {
    min-height: 100vh; 
    width: 100%;
    display: flex;
    flex-direction: column;
    background-image: url('@/assets/images/fundo_p2u.svg');
    background-color: #EFEFEF;
    background-repeat: no-repeat;
    background-position: right;
    background-size: cover;
    background-attachment: fixed;
}


</style>